import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useAsyncThrow } from './useAsyncThrow';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { CustomerStopDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { type TimeoutError } from '../recoil/types/types';
import { refreshExternalCasesAtom } from '../recoil/atoms/refreshExternalCasesAtom';

export function useQuoteJob(): {
    quoteJob: () => Promise<CustomerStopDTO>;
} {
    const { asyncThrow } = useAsyncThrow<Promise<CustomerStopDTO>>();
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const refreshExternalCases = useSetRecoilState(refreshExternalCasesAtom);
    const handleError = async (e: TimeoutError): Promise<CustomerStopDTO> =>
        !e.isHttpTimeout_Top ? await asyncThrow(e) : await Promise.resolve({ stopCause: 'None' });

    const quoteJob = async (): Promise<CustomerStopDTO> => {
        refreshExternalCases({});
        return await OnlineSales.quoteJob(jobNumber, sessionId).catch(handleError);
    };

    return { quoteJob };
}
